import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { NavigationEnd, Router, RouterEvent } from "@angular/router";
import { filter } from "rxjs/operators";
import { CacheConstant, CMSPages } from "../../../core/constants/app.constant";
import { AppCacheService } from "../../../core/services/cache/app-cache.service";
import { StaticPageContent } from "../../../shared/models/cms";
import { CmsService } from "../../../core/services/cms.service";
@Component({
    selector: 'par-product-catlog',
    template: '',
    // encapsulation:ViewEncapsulation.None
})
export class ProductCatlogComponent implements OnInit {
    private previousUrl: string;
    private currentUrl: string;
    isAuthenticated = false;
    cmsPageName: any;
    templateNum: any;
    envProperties = this.cache.get(CacheConstant.Env_Properties);
    constructor(private router: Router, private cms: CmsService,
      private cache: AppCacheService,) {
        this.getCmsContent();

    }
    ngOnInit() {
        setTimeout(() => {
            history.back();
        }, 500);
    }
    getCmsContent() {
        this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
        this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
        let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.userNotificAuthenticatedSeqNo : this.envProperties.cmsPageConfigVO.productCatalogUnauthenticatedSeqNo;
        this.cms.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName,2, this.templateNum, pageSeqNumber).subscribe((response: any) => {
          if (!response.hasError && response.length > 0) {
            let staticPageContent: StaticPageContent = response[0];
            let content = JSON.parse(staticPageContent.contentStructure);
            let businessManagedAlert = this.cms.prepareNotificMsg(staticPageContent);
            let documentNum = content.recordList[0].documentNum;
        this.cms.downloadDocumentFromHashTagNum(documentNum);

    
          }
        });
      }
    
}